import Vue from "vue";
import Vuetify from "vuetify/lib";
import { en, de } from "vuetify/src/locale";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: "#980729",
      },
    },
  },
  lang: {
    current: "en",
    locales: { en, de },
  },
});
